import React from 'react';
import ProfileDropdown from './ProfileDropdown';

const DropdownSituationActuelle = (props) => {

    const {
        dropdownProps = {},
        id = undefined
    } = props;

    return <ProfileDropdown
        {...dropdownProps}
        id={id}
        label="Situation actuelle"
        options={[
            { key: "Locataire", text: "Locataire" },
            { key: "Propriétaire", text: "Propriétaire" }
        ]}
    />;

};

export default DropdownSituationActuelle;